<template>
  <div class="products-page">

    <!-- Page header -->
    <div class="page-header">
      <button class="back-btn" onclick="window.history.back()"><i class="ft-arrow-left"></i></button>
      <div class="header-info">
        <span class="page-title">{{ menuTitle || 'Menu' }}</span>
        <span class="page-subtitle" v-if="menuTimes">
          <i class="ft-clock"></i> {{ menuTimes }}
        </span>
      </div>
      <router-link
        class="cart-btn"
        :to="'/preorder/' + $route.params.ward + '/' + $route.params.bed + '/' + $route.params.date + '/' + $route.params.period + '/categories'"
      >
        <i class="ft-shopping-cart"></i>
      </router-link>
    </div>

    <!-- Empty state -->
    <div class="empty-state" v-if="!loading && items.length === 0">
      <div class="empty-icon-wrap">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 2h18l-2 7H5L3 2z"/><path d="M5 9l1 11h12l1-11"/>
        </svg>
      </div>
      <p class="empty-title">No items available</p>
      <p class="empty-sub">There are no menu items for this period.</p>
    </div>

    <!-- Product grid -->
    <div class="section-pad" v-if="items.length > 0">
      <div class="product-grid">
        <div
          class="product-card"
          v-for="item in items"
          v-bind:key="item.id"
          v-if="showMeal(item)"
          v-on:click="viewMeal(item)"
        >
          <!-- Cart count badge -->
          <div class="cart-count" v-if="cartItemCount(item.id)">
            {{ cartItemCount(item.id) }}
          </div>

          <!-- Icon area -->
          <div class="product-icon-wrap" v-html="itemIconSvg(item)"></div>

          <!-- Info -->
          <span class="product-name">{{ item.label }}</span>
          <p class="product-desc" v-if="item.description">{{ item.description }}</p>

          <!-- Tags row -->
          <div class="product-tags">
            <span class="product-price" v-if="free_issue && item.price">R{{ item.price }}</span>
            <span class="additions-badge" v-if="item.additions && item.additions.length">
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
              {{ item.additions.length }} option{{ item.additions.length !== 1 ? 's' : '' }}
            </span>
          </div>

          <!-- Select button -->
          <div class="select-btn">Select</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import swal from 'sweetalert'

export default {
  name: 'products',
  data: function () {
    return {
      menuTitle: '',
      menuTimes: '',
      items: [],
      categories: [],
      category: '',
      free_issue: false,
      loading: true
    }
  },
  beforeDestroy: function () {
    $('.food-header-pic').remove()
  },
  mounted: function () {
    this.$store.commit('SET_LAYOUT', 'AppLayout')
    $('.food-header-pic').remove()

    var that = this
    var user = JSON.parse(window.localStorage.getItem('user'))
    var bed = JSON.parse(window.localStorage.getItem('bed'))
    var typeId = bed.menu_type_id
    var merchantId = user.merchant.id
    var date = window.localStorage.getItem('date')
    var period = null
    try { period = JSON.parse(localStorage.getItem('period')) } catch (e) {}

    // Parse period title — may be "Breakfast. Served: (07:30–09:30)" or just "Breakfast"
    var periodParts = ((period && period.title) || '').split('.')
    this.menuTitle = periodParts[0] ? periodParts[0].trim() : ((period && period.name) || '')
    this.menuTimes = periodParts[1] ? periodParts[1].trim() : ''

    if (window.localStorage.getItem('free_issue') === 'Y') {
      var free_issue_menus = JSON.parse(window.localStorage.getItem('free_menu'))
      that.items = free_issue_menus.menus
      that.free_issue = true
      that.loading = false
      return false
    }

    if (!period || !period.id) {
      that.loading = false
      swal({ text: 'No meal period found. Please go back and select a period.', icon: 'info', button: 'Ok' })
        .then(function () { that.$router.go(-1) })
      return
    }
    var url = this.$config.apiUrl + 'canteenapp_merchant/formatted_menu?type_id=' + typeId + '&merchant_id=' + merchantId + '&period=' + period.id + '&date=' + date

    $.ajax({
      beforeSend: function (xhr) {
        xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
      },
      url: url,
      type: 'get',
      success: function (data) {
        that.loading = false
        var categories = []
        var items = []

        window.localStorage.setItem('inclusions', JSON.stringify(data.data.global_additions))
        window.localStorage.setItem('exclusions', JSON.stringify(data.data.global_exclusions))

        if (data.data.menu_items) {
          data.data.menu_items.forEach(function (category) {
            categories.push({ title: category.meal_category, id: category.meal_category_id })
            category.menu_items.forEach(function (meal) {
              meal.meal_category_id = category.meal_category_id
              items.push(meal)
            })
          })
        }

        that.items = items
        that.categories = categories
        that.category = that.$route.params.category
      },
      error: function (data) {
        that.loading = false
        if (window.localStorage.getItem(this.url)) {
          var offlineData = JSON.parse(window.localStorage.getItem(this.url))
          this.success(offlineData)
        } else {
          swal({ text: data.responseJSON.message, icon: 'info', button: 'Ok' })
            .then(function () { that.logout() })
        }
      }
    })
  },
  methods: {
    logout: function () {
      localStorage.clear()
      this.$router.push('/login')
    },
    itemIconSvg: function (item) {
      var a = 'xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"'

      // Resolve category name
      var catName = ''
      for (var i = 0; i < this.categories.length; i++) {
        if (this.categories[i].id === item.meal_category_id) { catName = this.categories[i].title || ''; break }
      }
      // Label takes priority; category is a fallback
      var lbl = (item.label || '').toLowerCase()
      var cat = catName.toLowerCase()

      var cup    = '<svg ' + a + '><path d="M18 8h1a4 4 0 0 1 0 8h-1"/><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"/><line x1="6" y1="1" x2="6" y2="4"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="4"/></svg>'
      var egg    = '<svg ' + a + '><path d="M12 22c5.5 0 8-3.6 8-8.5C20 8.2 16.4 2 12 2S4 8.2 4 13.5C4 18.4 6.5 22 12 22z"/></svg>'
      var soup   = '<svg ' + a + '><path d="M2 12h20"/><path d="M4 12c0 4.4 3.6 8 8 8s8-3.6 8-8"/><path d="M9 4c0 1.7-2 3-2 5"/><path d="M14 4c0 1.7-2 3-2 5"/></svg>'
      var bread  = '<svg ' + a + '><path d="M3 7c0-2.2 1.8-4 4-4h10c2.2 0 4 1.8 4 4v1c0 1.1-.9 2-2 2v8a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-8c-1.1 0-2-.9-2-2V7z"/></svg>'
      var fish   = '<svg ' + a + '><path d="M6.5 12c-.5-2 1-5 5.5-5 5.5 0 9 3.5 9 5s-3.5 5-9 5c-4.5 0-6-3-5.5-5z"/><path d="M2 7l2.5 5L2 17"/><circle cx="17" cy="12" r="1"/></svg>'
      var leaf   = '<svg ' + a + '><path d="M2 22c4-4 8-12 18-14C19 18 12 22 2 22z"/><path d="M2 22 12 12"/></svg>'
      var fruit  = '<svg ' + a + '><path d="M12 20.94c1.5 0 2.75 1.06 4 1.06 3 0 6-8 6-12.22A4 4 0 0 0 17.66 6l-.64.14A4.76 4.76 0 0 1 12 6a4.76 4.76 0 0 1-5.02.14L6.34 6A4 4 0 0 0 2 9.78C2 14 5 22 8 22c1.25 0 2.5-1.06 4-1.06z"/><path d="M10 2c0 1.5 1 2.5 2 3"/></svg>'
      var cake   = '<svg ' + a + '><path d="M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8"/><path d="M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2 1 2 1"/><line x1="2" y1="21" x2="22" y2="21"/><path d="M7 8v3"/><path d="M12 8v3"/><path d="M17 8v3"/><path d="M7 4h.01"/><path d="M12 4h.01"/><path d="M17 4h.01"/></svg>'
      var bowl   = '<svg ' + a + '><path d="M3 11l19-9-9 19-2-8-8-2z"/></svg>'
      var star   = '<svg ' + a + '><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/></svg>'
      var knife  = '<svg ' + a + '><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/><path d="M7 2v20"/><path d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3zm0 0v7"/></svg>'

      // Tea / coffee / hot drinks — check label first
      if (/tea|coffee|rooibos|cocoa|milo|hot.?drink|beverage|juice|water|smoothie|shake/.test(lbl)) return cup
      // Eggs / breakfast items
      if (/\begg\b|omelette|scrambled|boiled|fried.?egg/.test(lbl)) return egg
      // Breakfast broad
      if (/breakfast|cereal|porridge|oat|muesli|pancake|waffle|granola/.test(lbl)) return egg
      // Soup / broth
      if (/soup|broth|chowder|bisque|veloute|consomme|minestrone/.test(lbl)) return soup
      // Fish / seafood
      if (/fish|tuna|salmon|hake|sardine|prawn|shrimp|calamari|seafood/.test(lbl)) return fish
      // Bread / sandwich / rolls / toast
      if (/sandwich|bread|roll|toast|wrap|roti|pita|bun|croissant|scone|muffin/.test(lbl)) return bread
      // Fruit (standalone fruit dishes)
      if (/\bfruit\b|apple|orange|banana|mango|grape|melon|berr/.test(lbl)) return fruit
      // Salad / vegetables / greens
      if (/salad|spinach|broccoli|vegetable|coleslaw|chakalaka|side.?salad/.test(lbl)) return leaf
      // Dessert / sweet
      if (/dessert|cake|pudding|jelly|custard|tart|biscuit|cookie|sweet|chocolate|sponge|crumble|mousse|ice.?cream/.test(lbl)) return cake
      // Starch / carbs on their own
      if (/\brice\b|pap|phuthu|pasta|spaghetti|noodle|potato|chips|maize/.test(lbl)) return bowl
      // Special / chef items
      if (/special|chef/.test(lbl)) return star

      // Category-level fallbacks
      if (/beverage|drink/.test(cat)) return cup
      if (/dessert|sweet/.test(cat)) return cake
      if (/soup/.test(cat)) return soup
      if (/salad|veg/.test(cat)) return leaf
      if (/special|chef/.test(cat)) return star

      // Default: fork & knife
      return knife
    },
    cartItemCount: function (menuId) {
      var cart = JSON.parse(window.localStorage.getItem('cart'))
      if (!cart) return false
      var currentPeriodId = null
      try { currentPeriodId = JSON.parse(window.localStorage.getItem('period')).id } catch (e) {}
      var count = 0
      cart.forEach(function (c) {
        if (c.mealId == menuId && (!currentPeriodId || c.period_id == currentPeriodId)) {
          count += Number(c.quantity)
        }
      })
      return count || false
    },
    showMeal: function (item) {
      if (this.category === '') return true
      return this.category === item.meal_category_id
    },
    viewMeal: function (item) {
      window.localStorage.setItem('meal', JSON.stringify(item))
      this.$router.push('/preorder/' + this.$route.params.ward + '/' + this.$route.params.bed + '/' + this.$route.params.date + '/' + this.$route.params.period + '/' + this.$route.params.category + '/products/' + item.id)
    }
  }
}
</script>

<style scoped>
.products-page {
  min-height: 100vh;
  background: #f0f4f8;
  padding-bottom: 40px;
}

/* ── Page header ── */
.page-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 30px 20px 20px;
  background: linear-gradient(135deg, #1a587b 0%, #0f3d5c 100%);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  margin-top: 3.2rem;
  border-radius: 0;
  box-shadow: 0 8px 32px rgba(15, 61, 92, 0.35);
}

.back-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #fb5653;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}
.back-btn:hover { background: #e03e3b; }

.header-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.page-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: capitalize;
}

.page-subtitle {
  font-size: 0.73rem;
  color: rgba(255, 255, 255, 0.65);
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
}
.page-subtitle i { font-size: 0.65rem; }

.cart-btn {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  text-decoration: none !important;
  flex-shrink: 0;
  transition: background 0.15s;
}
.cart-btn:hover { background: rgba(255, 255, 255, 0.25); }

/* ── Section ── */
.section-pad {
  padding: 110px 16px 0;
}

/* ── Empty state ── */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 120px 32px 40px;
  text-align: center;
}

.empty-icon-wrap {
  width: 72px;
  height: 72px;
  border-radius: 20px;
  background: #e0f2fe;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1a587b;
  margin-bottom: 4px;
}

.empty-title { font-size: 1rem; font-weight: 700; color: #0f172a; margin: 0; }
.empty-sub   { font-size: 0.85rem; color: #94a3b8; margin: 0; }

/* ── Product grid ── */
.product-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

@media (min-width: 768px) {
  .product-grid { grid-template-columns: repeat(3, 1fr); }
}

@media (min-width: 1024px) {
  .product-grid { grid-template-columns: repeat(4, 1fr); }
}

/* ── Product card ── */
.product-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  background: #fff;
  border-radius: 16px;
  padding: 20px 14px 14px;
  /* border: 2px solid #124564; */
  box-shadow: 0 -3px 8px rgba(18,69,100,0.18), 0 5px 14px rgba(18,69,100,0.22);
  cursor: pointer;
  text-align: center;
  transition: box-shadow 0.2s, transform 0.15s, border-color 0.2s;
}
.product-card:hover {
  box-shadow: 0 -4px 10px rgba(18,69,100,0.22), 0 7px 18px rgba(18,69,100,0.28);
  transform: translateY(-2px);
  border-color: #124564;
}
.product-card:active { transform: scale(0.97); }

/* Cart count badge */
.cart-count {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #fb5653;
  color: #fff;
  font-size: 0.65rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #f0f4f8;
  z-index: 1;
}

/* Icon area */
.product-icon-wrap {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: linear-gradient(135deg, #1a587b, #0f3d5c);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
}

.product-name {
  font-size: 0.82rem;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.35;
}

.product-desc {
  font-size: 0.72rem;
  color: #64748b;
  margin: 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.product-tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 5px;
}

.product-price {
  font-size: 0.68rem;
  font-weight: 700;
  color: #1a587b;
  background: #e0f2fe;
  padding: 2px 8px;
  border-radius: 6px;
}

.additions-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 0.62rem;
  font-weight: 700;
  color: #7c3aed;
  background: #ede9fe;
  padding: 2px 8px;
  border-radius: 6px;
}

/* Select button at bottom of card */
.select-btn {
  margin-top: auto;
  width: 100%;
  padding: 8px;
  background: linear-gradient(135deg, #1a587b, #0f3d5c);
  color: #fff;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.3px;
}
</style>
